import './RLoadingScreen.css';

interface RLoadingScreenProps {
  className?: string;
}

const RLoadingScreen: React.FC<RLoadingScreenProps> = ({ className = '' }) => {
  return (
    <div className={`flex justify-center items-center h-screen ${className}`}>
      <span className="loader"></span>
    </div>
  );
};

export default RLoadingScreen;